export default __webpack_public_path__ + "static/media/rust.3cdf5163.svg";